import { ToastOptions } from "react-toastify";

// The Toaster component draws its own icon. "colored" makes v11 use the per-type
// colour variables set in assets/styles/toaster instead of its light theme.
export const DEFAULT_OPTIONS: Partial<ToastOptions> = {
  position: "bottom-center",
  closeButton: false,
  hideProgressBar: true,
  icon: false,
  theme: "colored",
};
